const emojiIcons = {
    "🏀": "basketball",
    "⚽": "football",
    "⚾": "baseball",
    "🏓": "pingpong",
    "🏈": "american football",
    "🏏": "cricket",
    "🎾": "tennis",
    "🏊": "swimming",
    "🥋": "karate",
    "🏌️‍♂️": "golf",
    "🏸": "badminton",
    "🏑": "hockey",
    "🏒": "ice hockey",
    "🥍": "lacrosse",
    "🎣": "fishing",
    "🏐": "volleyball",
    "🏃‍♂️": "running",
    "🏄‍♂️": "surfing",
    "🎱": "8 ball pool",
    "🏎": "f1 racing",
    "🤼‍♂️": "wrestling",
    "🤽‍♂️": "water polo",
    "🥊": "boxing",
    "🛹": "skateboarding",
    "🎳": "bowling",
    "🏹": "archry",
    "🏉": "rugby",
    "🎿": "skis"
  };
  
  export default emojiIcons;
  